/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 請求明細
 * @export
 * @interface InvoiceItem
 */
export interface InvoiceItem {
    /**
     * サービスのID
     * @type {number}
     * @memberof InvoiceItem
     */
    serviceId: number;
    /**
     * サービス名
     * @type {string}
     * @memberof InvoiceItem
     */
    serviceName: string;
    /**
     * 単価(税抜)
     * @type {number}
     * @memberof InvoiceItem
     */
    unitPrice: number;
    /**
     * 数量
     * @type {number}
     * @memberof InvoiceItem
     */
    quantity: number;
    /**
     * 合計金額(税込)
     * @type {number}
     * @memberof InvoiceItem
     */
    totalPrice: number;
    /**
     * 合計金額(税抜)
     * @type {number}
     * @memberof InvoiceItem
     */
    totalPriceWithoutTax: number;
    /**
     * 税額
     * @type {number}
     * @memberof InvoiceItem
     */
    tax: number;
    /**
     * 税率(単位は%)
     * @type {number}
     * @memberof InvoiceItem
     */
    taxRate: number;
}

export function InvoiceItemFromJSON(json: any): InvoiceItem {
    return InvoiceItemFromJSONTyped(json, false);
}

export function InvoiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serviceId': json['service_id'],
        'serviceName': json['service_name'],
        'unitPrice': json['unit_price'],
        'quantity': json['quantity'],
        'totalPrice': json['total_price'],
        'totalPriceWithoutTax': json['total_price_without_tax'],
        'tax': json['tax'],
        'taxRate': json['tax_rate'],
    };
}

export function InvoiceItemToJSON(value?: InvoiceItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service_id': value.serviceId,
        'service_name': value.serviceName,
        'unit_price': value.unitPrice,
        'quantity': value.quantity,
        'total_price': value.totalPrice,
        'total_price_without_tax': value.totalPriceWithoutTax,
        'tax': value.tax,
        'tax_rate': value.taxRate,
    };
}

